module.exports = __webpack_public_path__ + "static/img/252_TO8_2241.e83d93c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/252_TO8_2241.jpg
// module id = Ua6J
// module chunks = 0